export default function IconSquareChevUp({ color = '#1E293B', width = 28, height = 28, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='-0.5'
        width='27'
        height='27'
        rx='3.5'
        transform='matrix(1 0 0 -1 0 27)'
        fill='#F5F5F5'
      />
      <rect
        x='0.5'
        y='-0.5'
        width='27'
        height='27'
        rx='3.5'
        transform='matrix(1 0 0 -1 0 27)'
        stroke='#CFCDDA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.71209 17.4754C8.0782 17.8415 8.6718 17.8415 9.03791 17.4754L14 12.5133L18.9621 17.4754C19.3282 17.8415 19.9218 17.8415 20.2879 17.4754C20.654 17.1093 20.654 16.5157 20.2879 16.1496L14.6629 10.5246C14.2968 10.1585 13.7032 10.1585 13.3371 10.5246L7.71209 16.1496C7.34597 16.5157 7.34597 17.1093 7.71209 17.4754Z'
        fill={color}
      />
    </svg>
  );
}
